/* eslint-disable react/no-array-index-key */
import { InstructionSet } from '../../../gql/prs/types';
import Label from '../../formComponents/Label';
import Instructions from './Instructions';

const AppInstructions = ({
  lienholderName,
  appInstructions,
}: {
  lienholderName: string;
  appInstructions: InstructionSet[];
}) => {
  return (
    <>
      <Label fontSize={{ md: '16px' }}>
        Get your payoff amount and good-through date by opening the {lienholderName} mobile app.
      </Label>
      {appInstructions.map((appInstruction, i) => (
        <Instructions key={`app-instruction-${i}`} instructions={appInstruction.instructions} />
      ))}
    </>
  );
};

export default AppInstructions;
